<template>
	<div>
        <div class="row">
            <el-card class="pb-4 pt-1" shadow="always" :body-style="{ padding: '10px'}" style="width:100%;">
                <div class="row">
                    <div class="col-md-6">
                        <el-button size="mini" @click="$router.push('/performance-report/non-fuel-retail')"><i class="fa fa-angle-left"></i></el-button>
                    </div>
                    <div class="col-md-6 text-right">
                        <el-button size="mini" @click="toggleFullscreen"><i :class="[toggleIcon ? 'fa-compress' : 'fa-arrows-alt', 'fa']"></i></el-button>
                        <el-button size="mini" @click="$router.push('/performance-report/losses-by-product')"><i class="fa fa-angle-right"></i></el-button>
                    </div>
                </div>

                <h4 class="text-center" style="color:#002060;"><b>SALES VOLUME YTD MEI 2023</b></h4>

                <el-form  class="mt-2" label-position="top" label-width="100px">
                    <div class="row">
                        <div class="col-md-2">	
                            <el-form-item label="Bulan:">
                                <el-select v-model="month" clearable filterable placeholder="Select Month" size="medium" style="width:100%;">
                                    <el-option v-for="item3 in options.months" :key="item3.value" :label="item3.name" :value="item3.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                        <div class="col-md-1">	
                            <el-form-item label="Tahun:" style="min-width:85px;">
                                <el-select v-model="year" clearable filterable placeholder="Select Year" size="medium" style="width:100%;">
                                    <el-option v-for="item3 in options.years" :key="item3.value" :label="item3.name" :value="item3.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                        <div class="col-md-1">	
                            <el-form-item label=" ">
                                <el-button type="primary" size="medium" :loading="loading.table" @click="applyFilter" style="width:100%;">Apply</el-button>
                            </el-form-item>
                        </div>
                    </div>
                </el-form>

                <el-table
                    :data="tableData"
                    stripe
                    v-loading="loading.table"
                    :border="true"
                    :show-header="true"
                    style="width: 100%; font-size:14px;"
                    :header-cell-style="{paddingTop: '8px', paddingBottom: '2px', background: '#F5F7FA'}"
                    :header-row-style="{padding:'0px'}"
                    :cell-style="{padding: '8px 0px', borderBottom: '1px solid #EBEEF5', borderRight: '0px solid #EBEEF5'}"   
                    class="no-border mt-2"
                    width="100%"
                    id="table">

                    <el-table-column
                        fixed
                        prop="product"
                        label="Jenis Produk"
                        header-align="center">
                    </el-table-column>

                    <el-table-column
                        fixed
                        prop="month_ytd"
                        label="YTD SEPTEMBER 2022"
                        header-align="center"
                        width="170"
                        align="right">
                    </el-table-column>

                    <el-table-column
                        label="2023 (Volume KL/KLSP)"
                        header-align="center">
                        <el-table-column
                            prop="volume_rkap"
                            label="RKAP"
                            width="120"
                            align="right"
                            header-align="center">
                        </el-table-column>
                        <el-table-column
                            prop="volume_rkap_ytd"
                            label="RKAP YTD"
                            width="120"
                            align="right"
                            header-align="center">
                        </el-table-column>
                        <el-table-column
                            prop="volume_real_ytd_month"
                            label="REAL YTD MEI"
                            width="170"
                            align="right"
                            header-align="center">
                        </el-table-column>
                    </el-table-column>

                    <el-table-column
                        label="% Real 2022 Terhadap"
                        header-align="center">
                        <el-table-column
                            prop="real_rkap_ytd"
                            label="RKAP YTD"
                            width="100"
                            align="right"
                            header-align="center">
                        </el-table-column>
                        <el-table-column
                            prop="real_rkap_month"
                            label="RKAP 2023"
                            width="100"
                            align="right"
                            header-align="center">
                        </el-table-column>
                        <el-table-column
                            prop="real_ytd_month"
                            label="YTD MEI 2022"
                            width="170"
                            align="right"
                            header-align="center">
                        </el-table-column>
                    </el-table-column>
                </el-table>
            </el-card>

        </div>
        
    </div>
</template>

<script>
import KinerjaKeuangan from '@/components/page/KinerjaKeuangan.js'

export default
{
	extends: KinerjaKeuangan,
	components: { 
		//ReportParamSelect,
	},

	data() {
		return {
            options: {
                months:[
                    {value:'1', name: 'Januari'},
                    {value:'2', name: 'Februari'},
                    {value:'3', name: 'Maret'},
                    {value:'4', name: 'April'},
                    {value:'5', name: 'Mei'},
                    {value:'6', name: 'Juni'},
                    {value:'7', name: 'Juli'},
                    {value:'8', name: 'Agustus'},
                    {value:'9', name: 'September'},
                    {value:'10', name: 'Oktober'},
                    {value:'11', name: 'November'},
                    {value:'12', name: 'Desember'},
                ],
                years:[
                    {value:'2021', name: '2021'},
                    {value:'2022', name: '2022'},
                    {value:'2023', name: '2023'},
                ],
            },
            month: '6',
            year: '2023',

            loading: {
                table: false,
            },

            tableData: [
                {
                    product: 'Gasoil (KL)',
                    month_ytd: '275.897',
                    volume_rkap: '657.823',
                    volume_rkap_ytd: '266.196',
                    volume_real_ytd_month: '312.565',
                    real_rkap_ytd: '117%',
                    real_rkap_month: '48%',
                    real_ytd_month: '113%',
                }, 
                {
                    product: 'Solar/Bio Solar',
                    month_ytd: '233.471',
                    volume_rkap: '540.149',
                    volume_rkap_ytd: '266.196',
                    volume_real_ytd_month: '312.565',
                    real_rkap_ytd: '117%',
                    real_rkap_month: '48%',
                    real_ytd_month: '113%',
                }, 
                {
                    product: 'Pertamina Dex',
                    month_ytd: '275.897',
                    volume_rkap: '657.823',
                    volume_rkap_ytd: '266.196',
                    volume_real_ytd_month: '312.565',
                    real_rkap_ytd: '117%',
                    real_rkap_month: '48%',
                    real_ytd_month: '113%',
                }, 
                {
                    product: 'Dexlite',
                    month_ytd: '275.897',
                    volume_rkap: '657.823',
                    volume_rkap_ytd: '266.196',
                    volume_real_ytd_month: '312.565',
                    real_rkap_ytd: '117%',
                    real_rkap_month: '48%',
                    real_ytd_month: '113%',
                },
                {
                    product: 'Gasoline (KL)',
                    month_ytd: '275.897',
                    volume_rkap: '657.823',
                    volume_rkap_ytd: '266.196',
                    volume_real_ytd_month: '312.565',
                    real_rkap_ytd: '117%',
                    real_rkap_month: '48%',
                    real_ytd_month: '113%',
                },
                {
                    product: 'Pertamax',
                    month_ytd: '275.897',
                    volume_rkap: '657.823',
                    volume_rkap_ytd: '266.196',
                    volume_real_ytd_month: '312.565',
                    real_rkap_ytd: '117%',
                    real_rkap_month: '48%',
                    real_ytd_month: '113%',
                },
                {
                    product: 'Pertamax Turbo',
                    month_ytd: '275.897',
                    volume_rkap: '657.823',
                    volume_rkap_ytd: '266.196',
                    volume_real_ytd_month: '312.565',
                    real_rkap_ytd: '117%',
                    real_rkap_month: '48%',
                    real_ytd_month: '113%',
                },
                {
                    product: 'Pertalite',
                    month_ytd: '275.897',
                    volume_rkap: '657.823',
                    volume_rkap_ytd: '266.196',
                    volume_real_ytd_month: '312.565',
                    real_rkap_ytd: '117%',
                    real_rkap_month: '48%',
                    real_ytd_month: '113%',
                },
                {
                    product: 'Pertalite (PLK)',
                    month_ytd: '275.897',
                    volume_rkap: '657.823',
                    volume_rkap_ytd: '266.196',
                    volume_real_ytd_month: '312.565',
                    real_rkap_ytd: '117%',
                    real_rkap_month: '48%',
                    real_ytd_month: '113%',
                },
                {
                    product: 'Total',
                    month_ytd: '275.897',
                    volume_rkap: '657.823',
                    volume_rkap_ytd: '266.196',
                    volume_real_ytd_month: '312.565',
                    real_rkap_ytd: '117%',
                    real_rkap_month: '48%',
                    real_ytd_month: '113%',
                },
                {
                    product: 'Vigas',
                    month_ytd: '275.897',
                    volume_rkap: '657.823',
                    volume_rkap_ytd: '266.196',
                    volume_real_ytd_month: '312.565',
                    real_rkap_ytd: '117%',
                    real_rkap_month: '48%',
                    real_ytd_month: '113%',
                },
                {
                    product: 'BBG (KLsp)',
                    month_ytd: '275.897',
                    volume_rkap: '657.823',
                    volume_rkap_ytd: '266.196',
                    volume_real_ytd_month: '312.565',
                    real_rkap_ytd: '117%',
                    real_rkap_month: '48%',
                    real_ytd_month: '113%',
                },
                {
                    product: 'Grand Total',
                    month_ytd: '275.897',
                    volume_rkap: '657.823',
                    volume_rkap_ytd: '266.196',
                    volume_real_ytd_month: '312.565',
                    real_rkap_ytd: '117%',
                    real_rkap_month: '48%',
                    real_ytd_month: '113%',
                },
            ]
        }
    },
    watch: {

	}, 
    mounted() {
        this.$emit('childrenRoute');
    },
    methods: {
        applyFilter() {
            console.log('apply filter');
        },
    },
}
</script>